import { Navigate } from "react-router";
import { signupEnabled } from "./authConfig";
import { SignupPage } from "./SignupPage";

/** Signup is not a product surface unless VITE_ENABLE_SIGNUP=true. */
export const SignupRoute = () => {
  if (!signupEnabled) {
    return <Navigate to="/login" replace />;
  }
  return <SignupPage />;
};
